import { createSelector } from 'reselect';
import { languageSelector } from './languageSelector';
import Auth from '../../models/Auth';

export const getAuth = (state) => state.global.auth;

export const getAuthState = createSelector(
  [getAuth, languageSelector],
  (auth) => new Auth(auth),
);
